import React, { useEffect, useState } from 'react';
import IconLink from 'components/IconLink';

import CardContainer from 'containers/CardContainer';
import ResponsiveCard from 'containers/ResponsiveCard';
import ListActionsContainer from 'pages/MenuItems/containers/ListActionsContainer';
import ListLayout from 'pages/MenuItems/containers/ListLayout';
import ResponsiveSpacer from 'pages/MenuItems/components/ResponsiveSpacer';
import ResponsiveTitleContainer from 'pages/MenuItems/containers/ResponsiveTitleContainer';
import FormTitle from 'pages/MenuItems/components/FormTitle';

import Table from 'components/Table';
import structure from './structure';
import useI18n from 'i18n/useI18n';
import DragHandle from 'components/Table/DragHandle';
import useProducts from 'state/products';
import MainLayout from 'containers/MainLayout';
import useCategories from 'state/categories';
import Filters from './components/Filters';
import useFilters from 'state/filters';


import { EditPricesProvider } from '../List/providers/EditPricesProvider';

const List = ({ location }) => {
    const { translate } = useI18n();
    const [data, productsDispatcher] = useProducts();
    const [, categoriesDispatcher] = useCategories();
    const [list, setList] = useState([]);
    const [filters] = useFilters();


    useEffect(() => {
        productsDispatcher.fetchStart();
        categoriesDispatcher.fetchStart();
    }, []);

    const onSort = ({ newIndex, oldIndex, commitMove }) => {
        const element = list[oldIndex];
        const selectedCategoryId = filters.items.arrangeSelectedCategory.value;
        const selectedSubcategoryId = filters.items.arrangeSelectedSubcategory.value;
        const targetCategory = selectedSubcategoryId === -2 ? selectedCategoryId : selectedSubcategoryId;
        const currentCategoryAssignment = element.categories.find(({ category }) => category === targetCategory);

        if(newIndex === oldIndex && currentCategoryAssignment.position === newIndex + 1) return;

        if(newIndex === 0) {
            commitMove();

            productsDispatcher.position({
                categoryId:  targetCategory,
                productId: element.id,
                position: newIndex + 1,
            });
            return;
        }

        const previousElement = list[newIndex-1];
        const previousElementCategoryAssignment = previousElement.categories.find(({ category }) => category === targetCategory);

        if(!previousElementCategoryAssignment || !previousElementCategoryAssignment.position) {
            return;
        }

        commitMove();
        productsDispatcher.position({
            categoryId: targetCategory,
            productId: element.id,
            position: newIndex + 1,
        });
    
    };

    return (        
        <EditPricesProvider>
            <MainLayout location={location}>
                <ListLayout>
                    <ListActionsContainer>
                        <IconLink to={'/menu/items'}>{translate('Back to Menu Items')}</IconLink>

                        <ResponsiveTitleContainer>
                            <FormTitle>{translate('Arrange')}</FormTitle>
                        </ResponsiveTitleContainer>
                        
                        <div style={{ flex: '2' }}></div>
                        <Filters
                            data={data}
                            setList={setList}
                        />
                    </ListActionsContainer>
                    <ResponsiveSpacer />
                    <CardContainer>
                        <ResponsiveCard>
                            <Table
                                items={list}
                                structure={structure}
                                config={{ translate, selectedCategory: filters.items.arrangeSelectedCategory, selectedSubcategory: filters.items.arrangeSelectedSubcategory }}
                                onSortEnd={onSort}
                                dragHandle={<DragHandle />}
                                dragable={true}
                            />
                        </ResponsiveCard>
                    </CardContainer>
                </ListLayout>
            </MainLayout>
        </EditPricesProvider>
    );
};

export default List;
